import "./column-components.b2a20dc1.js";
import {useRef as $OHKlF$useRef, useCallback as $OHKlF$useCallback, useEffect as $OHKlF$useEffect} from "react";
import $OHKlF$uibox from "ui-box";
import $OHKlF$macrostrathyper from "@macrostrat/hyper";


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea149"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea149"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $4cfd4c889e62287b$exports = {};

$parcel$export($4cfd4c889e62287b$exports, "ColumnScroller", () => $4cfd4c889e62287b$export$e60368c40bae9fd4);




var $aVUB5 = parcelRequire("aVUB5");
function $4cfd4c889e62287b$export$e60368c40bae9fd4(props) {
    const { onScrolled: onScrolled = $4cfd4c889e62287b$var$defaultOnScrolled, scrollContainer: scrollContainer = $4cfd4c889e62287b$var$defaultGetScrollContainer, scrollToHeight: scrollToHeight, paddingTop: paddingTop, animated: animated, alignment: alignment, ...rest } = props;
    const ref = (0, $OHKlF$useRef)(null);
    const ctx = (0, $aVUB5.useColumn)();
    const columnScale = ctx?.scale;
    const scrollTo = (0, $OHKlF$useCallback)((height, opts)=>{
        let node = ref.current;
        if (node == null || columnScale == null) return;
        let { animated: animated, alignment: alignment } = opts;
        if (animated == null) animated = false;
        const pixelOffset = columnScale(height);
        const { top: top } = node.getBoundingClientRect();
        node = scrollContainer();
        let pos = pixelOffset + top + paddingTop;
        const screenHeight = window.innerHeight;
        if (alignment === "center") pos -= screenHeight / 2;
        else if (alignment === "bottom") pos -= screenHeight;
        if (animated && "scrollBehavior" in document.documentElement.style) node.scrollTo({
            top: pos,
            behavior: "smooth"
        });
        else node.scrollTop = pos;
    }, [
        onScrolled,
        scrollContainer,
        ref.current,
        columnScale,
        paddingTop
    ]);
    (0, $OHKlF$useEffect)(()=>{
        const { scrollToHeight: scrollToHeight, alignment: alignment } = props;
        if (scrollToHeight == null) return;
        // Actually perform the scroll
        scrollTo(scrollToHeight, {
            alignment: alignment,
            animated: animated
        });
        return onScrolled(scrollToHeight);
    }, [
        scrollTo,
        scrollToHeight
    ]);
    const { pixelHeight: pixelHeight } = this.context;
    return (0, $OHKlF$macrostrathyper)((0, $OHKlF$uibox), {
        height: pixelHeight,
        position: "absolute",
        ref: ref,
        ...rest
    });
}
function $4cfd4c889e62287b$var$defaultOnScrolled(height) {
    console.log(`Scrolled to ${height} m`);
}
function $4cfd4c889e62287b$var$defaultGetScrollContainer() {
    // Todo: generalize this
    return document.querySelector(".panel-container");
}


export {$4cfd4c889e62287b$export$e60368c40bae9fd4 as ColumnScroller};
//# sourceMappingURL=column-components.fac5b590.js.map
